import React, { ReactElement } from 'react';
import { Row } from 'antd';

import { useClientFormContext } from '../ClientFormContext';
import ClientFormHeader from '../../../components/Client/ClientFormHeader';
import ClientForm from '../ClientForm';
import ClientCredentialsFormSection from '../../../components/Feature/ClientCredentialsFormSection';
import { submitClientCredentialsFactory } from '../utils/submit';

const ClientCredentialsForm: React.FC = (): React.ReactElement => {
    const { client, data, formConfig } = useClientFormContext();

    return (
        <>
            <div className="shadow-sm pb-4">
                <ClientFormHeader />
                <div className="px-4">
                    <ClientForm name="credentials" submitForm={client && submitClientCredentialsFactory(client.id)}>
                        {({ form }): ReactElement => (
                            <>
                                <Row>
                                    <p>
                                        These credentials are used, at the moment, only by ex-Monocle client
                                        integrations. They allow the integrations middleware to authenticate as a client
                                        on the Stuart API.
                                    </p>
                                </Row>
                                <ClientCredentialsFormSection
                                    form={form}
                                    isDetailMode={formConfig.isDetailMode}
                                    clientCredentials={data.clientCredentials}
                                />
                            </>
                        )}
                    </ClientForm>
                </div>
            </div>
        </>
    );
};

export default ClientCredentialsForm;
